export default "__VITE_ASSET__Bzie4IZs__"